module.exports = __webpack_public_path__ + "img/logo_saude.35b59350.png";